import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // No caching - data is always stale
      staleTime: 0,
      gcTime: 0,

      // Disable all retry attempts
      retry: false,

      // Only refetch when explicitly mounted in components
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
    mutations: {
      // Disable mutation retries
      retry: false,
    },
  },
});
